import {
	useCallback, useEffect, useRef, useState
} from 'react';
import { useInView } from 'react-intersection-observer';

function useProductOffering(onTrack: (current: Element) => any) {

	const timer = useRef<ReturnType<typeof setTimeout>>();
	const ref = useRef<Element>();
	const [tracked, setTracked] = useState(false);

	/*
		Style Note: The component must be 75% visible in the parent element.
		Ensure the component is not occluded such as by parent overflow: hidden
	*/
	const [inViewRef, inView] = useInView({
		threshold: 0.75
	});

	// Composes the element ref and the InViewRef
	const setRefs = useCallback(
		(node: Element) => {

			ref.current = node;
			inViewRef(node);

		},
		[inViewRef]
	);

	// Callback to track the Sku View once the view qualifies against VISIBILITY_DURATION
	const track = useCallback(() => {

		if (!tracked && ref.current) {

			onTrack(ref.current);
			setTracked(true);

		}

	}, [ref, tracked]);

	// Start and stop the visibility timer
	useEffect(() => {

		if (!tracked && inView) {

			timer.current = setTimeout(track, 500);

		} else {

			clearTimeout(timer.current);

		}

	}, [inView, setTracked, timer, track, tracked]);

	return {
		setRefs
	};

}

export default useProductOffering;
